import type { FilterGroup } from "@/components/feature/FilterPanel";
import {
  genreOptions,
  regionOptions,
  yearOptions,
  sortOptions,
} from "@/mocks/filters";

export const PAGE_SIZE = 8;

export function buildFilterGroups(): FilterGroup[] {
  return [
    {
      key: "genre",
      label: "类型",
      icon: "ri-price-tag-3-line",
      options: genreOptions.map((g) => ({ label: g, value: g })),
    },
    {
      key: "region",
      label: "地区",
      icon: "ri-earth-line",
      options: regionOptions.map((r) => ({ label: r, value: r })),
    },
    {
      key: "year",
      label: "年份",
      icon: "ri-calendar-line",
      options: yearOptions.map((y) => ({ label: y, value: y })),
    },
    {
      key: "sort",
      label: "排序",
      icon: "ri-sort-desc",
      options: sortOptions.map((s) => ({ label: s.label, value: s.value })),
    },
  ];
}

export const defaultFilterValues: Record<string, string> = {
  genre: "全部",
  region: "全部",
  year: "全部",
  sort: "hot",
};

export function buildSearchFilterGroups(): FilterGroup[] {
  return [
    {
      key: "type",
      label: "内容类型",
      icon: "ri-layout-grid-line",
      options: [
        { label: "全部", value: "all" },
        { label: "电影", value: "movie" },
        { label: "电视剧", value: "tv" },
        { label: "综艺", value: "variety" },
      ],
    },
    {
      key: "genre",
      label: "类型题材",
      icon: "ri-price-tag-3-line",
      options: genreOptions.map((g) => ({ label: g, value: g })),
    },
    {
      key: "region",
      label: "地区",
      icon: "ri-earth-line",
      options: regionOptions.map((r) => ({ label: r, value: r })),
    },
    {
      key: "year",
      label: "年份",
      icon: "ri-calendar-line",
      options: yearOptions.map((y) => ({ label: y, value: y })),
    },
    {
      key: "sort",
      label: "排序",
      icon: "ri-sort-desc",
      options: sortOptions.map((s) => ({ label: s.label, value: s.value })),
    },
  ];
}

export const defaultSearchValues: Record<string, string> = {
  type: "all",
  genre: "全部",
  region: "全部",
  year: "全部",
  sort: "hot",
};